import styled from 'styled-components'

export const DivIntro = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  gap: 0.5rem;
  margin-bottom: 24px:
`

export const ButtonContainer = styled.div`
  margin-bottom: 24px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const IntroImage = styled.div`
  width: 100vw;
  max-width: 100vw;
  height: 35vh;
  max-height: 35vh;
  display: flex;
  align-self: center;
  justify-self: center;
  justify-content: center;
  align-items: center;

  @media (min-width: 512px) {
    height: 50vh;
    max-height: 50vh;
  }
`

export const LogoImage = styled.img`
  width: 100vw;
  max-height: 35vh;
  object-fit: cover;

  @media (min-width: 512px) {
    max-height: 50vh;
  }
`

export const IgnoreWidthPadding = styled.div`
  width: calc(100% + 48px);
  margin-left: -24px;
`
